/** Dining lifecycle phases returned by GET /tables/floor */
export const DINING_PHASE = {
  seated: { label: "Seated", short: "Seated", color: "text-sky-700", bg: "bg-sky-100" },
  ordering: { label: "Ordering", short: "Order", color: "text-violet-700", bg: "bg-violet-100" },
  kitchen: { label: "In kitchen", short: "Kitchen", color: "text-orange-700", bg: "bg-orange-100" },
  ready: { label: "Ready to serve", short: "Ready", color: "text-emerald-700", bg: "bg-emerald-100" },
  dining: { label: "Dining", short: "Eating", color: "text-rose-700", bg: "bg-rose-100" },
  awaiting_payment: { label: "Bill printed", short: "Pay", color: "text-amber-800", bg: "bg-amber-100" },
};

export function diningPhaseMeta(phase) {
  return DINING_PHASE[phase] || DINING_PHASE.dining;
}

export function formatSessionPreview(session) {
  if (!session) return "";
  const preview = session.item_preview;
  if (Array.isArray(preview) && preview.length > 0) {
    const tail = session.item_count > preview.length ? ` +${session.item_count - preview.length}` : "";
    return `${preview.join(", ")}${tail}`;
  }
  if (session.item_count > 0) {
    return `${session.item_count} items`;
  }
  return "Guests seated";
}
